import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => ({
  showToBottom: false,
  isTyping: false,
  all_users: [],
  selectedUser: null,
});

const initialState = getInitialState();

const persistConfig = {
  key: "sendBoxConnect",
  storage,
  whitelist: [], // place to select which state you want to persist
};

const sendBoxConnectSlice = createSlice({
  name: "sendBoxConnect",
  initialState,
  reducers: {
    changeShowToBottom: (state, action) => {
      state.showToBottom = action.payload;
    },
    setIsTyping: (state, action) => {
      state.isTyping = action.payload;
    },
    clearSendBoxConnect: () => getInitialState(),
  },
});

export const {
  changeShowToBottom,
  setIsTyping,
  clearSendBoxConnect,
} = sendBoxConnectSlice.actions;

export default persistReducer(persistConfig, sendBoxConnectSlice.reducer);
